import { useContext } from "react";
import { JourneysContext } from "../../context/journeys-context";
import DatePickerDropdown from "components/calendar/date-picker-dropdown";

const JourneysTaskDueDate = () => {
  const { onStageWithTable, selectedDueDate, setSelectedDueDate, renderEmptyState } = useContext(JourneysContext);

  return (
    !onStageWithTable &&
    !renderEmptyState && (
      <DatePickerDropdown
        date={selectedDueDate}
        onDayClick={(date) => setSelectedDueDate(date)}
        triggerClassName={"journeys-date-dropdown"}
        chevronClassName={"date-picker-chevron"}
        allowClear={false}
        buttonType="simple"
      />
    )
  );
};

export default JourneysTaskDueDate;
